var map = {
	"./demos/basic/index.ts": 5648,
	"./demos/content/index.ts": 99631,
	"./demos/overlay/index.ts": 68323,
	"./demos/placement/index.ts": 9516,
	"./demos/resizable/index.ts": 60681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47423;